const countryMixin = {
  data() {
    return {
      mapperCurrencyCodeToCountryCode: {
        BRL: 'BR',
        COP: 'CO',
        CLP: 'CL',
        MXN: 'MX',
      },
    }
  },
}

export default countryMixin
